import React, { useState } from 'react';
import formatter from '../../../utilities/formatter';
import FormControl from '../inputs/FormControl';
import PropTypes from 'prop-types';

const PercentInput = ({
    name,
    onChange,
    value,
    ...passThroughProps
}) => {
    const [displayValue, setDisplayValue] = useState((value === '' || value === null)
        ? null : formatter.percent(value));

    const formatText = (e) => {
        if (e.target.value !== '') {
            //strip non number characters
            const validatedText = e.target.value.replace(/[^0-9\-.]/g, '').replace(/(\..*)\./g, '$1');

            if (e.target.value === validatedText) {
                onChange({ target: { name: e.target.name, type: 'number', value: parseFloat(e.target.value)}});
            } else {
                e.preventDefault();
            }
        } else {
            onChange(e);
        }

        setDisplayValue(e.target.value);
    }

    //set display to currency format string
    const convertTo = () => {
        if (value === '' || value === null) {
            setDisplayValue('');
        } else {
            setDisplayValue(formatter.percent(value));
        }
    }

    //convert currency format string to float for editing
    const convertBack = () => {
        if (value !== '' || value !== null) {
            setDisplayValue(value);
        }
    }

    return (
        <FormControl
            className='text-right'
            {...passThroughProps}
            name={name}
            onBlur={convertTo}
            onChange={formatText}
            onFocus={convertBack}
            value={displayValue || ''}
        />
    );
}

PercentInput.propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChange: PropTypes.func
};

export default PercentInput;